import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { useShop } from "@/context/ShopContext";

const NAV = [
  { to: "/shop", label: "Shop" },
  { to: "/collections", label: "Collections" },
  { to: "/fabric-guide", label: "Fabric Guide" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/wishlist", label: "Wishlist" },
  { to: "/cart", label: "Cart" },
];

const CARE = [
  { to: "/track", label: "Track Order" },
  { to: "/customer-care#shipping", label: "Shipping" },
  { to: "/customer-care#returns", label: "Returns" },
  { to: "/customer-care#privacy", label: "Privacy Policy" },
  { to: "/customer-care#terms", label: "Terms & Conditions" },
];

export default function Footer() {
  const { settings } = useShop();
  const instagram = settings?.instagram || "Lamsahksa";
  const email = settings?.store_email || "Lamsahhijabs@gmail.com";
  return (
    <footer data-testid="site-footer" className="bg-espresso text-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <p className="font-serif text-4xl tracking-[0.25em]">LAMSAH</p>
            <p className="font-arabic text-2xl text-ivory/70 mt-2" lang="ar" dir="rtl">لمسة</p>
            <p className="text-sm text-ivory/60 leading-relaxed mt-6 max-w-xs">
              A touch of softness. A touch of elegance. Timeless hijabs, thoughtfully
              chosen for the modern woman.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-ivory/50 mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} data-testid={`footer-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-ivory/80 hover:text-ivory transition-colors duration-300">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-ivory/50 mb-5">Customer Care</p>
            <ul className="space-y-3">
              {CARE.map((c) => (
                <li key={c.label}>
                  <Link to={c.to} data-testid={`footer-care-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-ivory/80 hover:text-ivory transition-colors duration-300">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-ivory/50 mb-5">Connect</p>
            <a
              href={`https://www.instagram.com/${instagram}`}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="text-sm text-ivory/80 hover:text-ivory transition-colors duration-300 flex items-center gap-2"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.5} /> @{instagram}
            </a>
            <a
              href={`mailto:${email}`}
              data-testid="footer-email"
              className="text-sm text-ivory/80 hover:text-ivory transition-colors duration-300 flex items-center gap-2 mt-3 break-all"
            >
              <Mail className="w-4 h-4 shrink-0" strokeWidth={1.5} /> {email}
            </a>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-ivory/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-ivory/50 tracking-wide">© 2026 LAMSAH. All rights reserved.</p>
          <p className="text-xs text-ivory/40 tracking-[0.2em] uppercase">Every Shade. Your Style.</p>
        </div>
      </div>
    </footer>
  );
}
